module.exports = __webpack_public_path__ + "img/play.8c1b832.png";